import { useContext } from "react"
import { ScenarioStatesProviderContext } from "../providers/StatesProvider"

const useSocket = () => {
    const context = useContext(ScenarioStatesProviderContext)
    if (!context) {
        throw new Error('useSocket must be used within a SocketProvider')
    }
    const { socket, setSocket } = context
    return { socket, setSocket }
}
export default useSocket